import { Translate } from 'next-translate';

import { ID, LotChanges } from 'types';
import { hasEmptyNewLot } from './emptyLot';

interface AddLotTooltipParams {
  isReadOnly: boolean;
  lotChanges: Record<ID, LotChanges>;
  t: Translate;
}

export const addLotTooltip = ({
  isReadOnly,
  lotChanges,
  t,
}: AddLotTooltipParams) => {
  const name = t('general.add_lot');
  if (isReadOnly) {
    return t('bid_request.line_items.tooltips.disabled_action', {
      action: t('bid_request.line_items.tooltips.actions.add_lots'),
    });
  }
  if (!hasEmptyNewLot(lotChanges)) return '';
  const reason = t('bid_request.line_items.tooltips.reasons.has_lot_with_empty_fields');

  return t('bid_request.line_items.tooltips.disabled_with_reason', { name, reason });
};
